export default __webpack_public_path__ + "static/media/NoteTaker.c04a3ac4.gif";